var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M31.167 5.50016H38.5003C38.9866 5.50016 39.4529 5.69332 39.7967 6.03713C40.1405 6.38095 40.3337 6.84727 40.3337 7.3335V36.6668C40.3337 37.1531 40.1405 37.6194 39.7967 37.9632C39.4529 38.307 38.9866 38.5002 38.5003 38.5002H5.50033C5.0141 38.5002 4.54778 38.307 4.20396 37.9632C3.86015 37.6194 3.66699 37.1531 3.66699 36.6668V7.3335C3.66699 6.84727 3.86015 6.38095 4.20396 6.03713C4.54778 5.69332 5.0141 5.50016 5.50033 5.50016H12.8337V1.8335H16.5003V5.50016H27.5003V1.8335H31.167V5.50016ZM7.33366 16.5002V34.8335H36.667V16.5002H7.33366ZM11.0003 20.1668H14.667V23.8335H11.0003V20.1668ZM11.0003 27.5002H14.667V31.1668H11.0003V27.5002ZM18.3337 20.1668H33.0003V23.8335H18.3337V20.1668ZM18.3337 27.5002H27.5003V31.1668H18.3337V27.5002Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c624309d36a6c1d4086e6c2e5e6f702b.svg";
export { ForwardRef as ReactComponent };